/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserDocumentDto } from '../../models/user-document-dto';

export interface UploadUserDocument$Params {
  userId: number;
  encryptionKey: string;
  nonce: string;
  comment?: string;
  fileCreatedAt: string;
  fileModifiedAt: string;
  userVerificationId?: number;
  fileSha1Hash: string;
  'X-API-Version'?: string;
      body?: {
'file': Blob;
}
}

export function uploadUserDocument(http: HttpClient, rootUrl: string, params: UploadUserDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDocumentDto>> {
  const rb = new RequestBuilder(rootUrl, uploadUserDocument.PATH, 'post');
  if (params) {
    rb.query('userId', params.userId, {});
    rb.query('encryptionKey', params.encryptionKey, {});
    rb.query('nonce', params.nonce, {});
    rb.query('comment', params.comment, {});
    rb.query('fileCreatedAt', params.fileCreatedAt, {});
    rb.query('fileModifiedAt', params.fileModifiedAt, {});
    rb.query('userVerificationId', params.userVerificationId, {});
    rb.query('fileSha1Hash', params.fileSha1Hash, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserDocumentDto>;
    })
  );
}

uploadUserDocument.PATH = '/api/user-documents';
